const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

class HoursManager {
  constructor(hours) {
    this.hours = false;
    this.ot = "";
    this.ct = "";
    this.unscheduled = false;
    this.alwaysOpen = false;
  }

  popHours(h) {
    this.hours = h;
  }

  convertHoursMinutes(time) {
    let t = time.split(":");
    return parseInt(t[0]) * 60 + parseInt(t[1]);
  }

  formatMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60); // Get the number of full hours
    const minutes = totalMinutes % 60; // Get the remaining minutes using modulo operator

    // Format hours and minutes to ensure two digits (e.g., 05 instead of 5)
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}`;
  }

  checkOpen(ot, ct) {
    let currentTime = new Date();
    let currentMinute = currentTime.getMinutes() + currentTime.getHours() * 60;
    this.ot = this.formatMinutes(ot);
    this.ct = this.formatMinutes(ct);
    return currentMinute >= ot && currentMinute <= ct ? true : false;
  }

  updateUnscheduled(open) {
    let date = new Date().toLocaleDateString();
    let time = new Date().getHours() + ":" + new Date().getMinutes();
    let openTime = open ? time : "23:59";
    let closeTime = open ? "23:59" : time;
    this.hours.unscheduled = {
      date: date,
      name: "Unscheduled",
      open: open,
      openTime: openTime,
      closeTime: closeTime,
    };
  }

  removeUnscheduled() {
    delete this.hours.unscheduled;
  }

  openTime() {
    if (this.unscheduled) {
      return "tomorrow";
    } else {
      return this.ot;
    }
  }

  closeTime() {
    return this.ct;
  }

  isOpenNow() {
    if (!this.hours || this.alwaysOpen) return true;
    let currentTime = new Date();

    if (
      !(this.hours && "unscheduled" in this.hours) ||
      (this.hours.unscheduled.date !== currentTime.toLocaleDateString() &&
        !this.hours["holiday" + new Date().getFullYear()].find((e) => e.date == currentTime.toLocaleDateString()))
    ) {
      let day = this.hours.week.find((d) => d.name == days.at(currentTime.getDay()));
      return this.checkOpen(this.convertHoursMinutes(day.openTime), this.convertHoursMinutes(day.closeTime));
    }

    if (this.hours["holiday" + new Date().getFullYear()] != undefined && this.hours["holiday" + new Date().getFullYear()].find((e) => e.date == currentTime.toLocaleDateString())) {
      let fullyear = new Date().getFullYear();
      let holiday = this.hours["holiday" + fullyear].find((e) => e.date == currentTime.toLocaleDateString());
      return this.checkOpen(this.convertHoursMinutes(holiday.openTime), this.convertHoursMinutes(holiday.closeTime));
    }

    if (this.hours && "unscheduled" in this.hours && this.hours.unscheduled.date == currentTime.toLocaleDateString()) {
      this.unscheduled = true;
      return this.checkOpen(this.convertHoursMinutes(this.hours.unscheduled.openTime), this.convertHoursMinutes(this.hours.unscheduled.closeTime));
    }
  }
}

const hours = new HoursManager();
export { hours };
